var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogovIconcPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187.06934,
    height: 149.85199,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 792h792V0H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 -65.199997 602.92584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-30.639-15.688 18.81-28.898 46.585 71.573H-58.415l8.483-13.032c.115-.169.223-.343.325-.519.738-1.276 1.162-2.756 1.162-4.335 0-4.786-3.882-8.667-8.668-8.667-3.466 0-6.456 2.036-7.843 4.975l-14.611 22.448c-.507.78-.99 1.46-1.427 2.289-.64 1.304-1 2.772-1 4.324 0 5.228 4.082 9.501 9.234 9.807l.593.019H48.48c.551 0 .818-.019 1.364-.095 4.782-.662 8.464-4.766 8.464-9.731 0-1.338-.268-2.614-.751-3.775-.27-.646-.655-1.244-1.005-1.849L-2.822-62.377c-.509-.78-.961-1.521-1.556-2.228-1.802-2.132-4.497-3.488-7.509-3.488-1.545 0-2.988.37-4.272 1.017-1.966.989-3.269 2.607-4.6 4.58l-28.674 44.057c-.39.597-.865 1.289-1.206 1.909-.681 1.236-1.068 2.659-1.068 4.171 0 2.852 1.377 5.381 3.503 6.961 1.054.781 3.969 2.112 5.148 2.715L-9.808 14.34c1.536.787 3.103 1.676 4.639 2.424 1.101.538 2.399 1.004 3.953 1.004 4.787 0 8.667-3.881 8.667-8.667 0-2.534-1.088-4.814-2.822-6.398C3.355 1.539 1.545.791 0 0",
    style: {
      fill: "#058ff2",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(130.894 407.8984)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogovIconcPrimary);
export default __webpack_public_path__ + "static/media/logo.v-icon.c-primary.65957641dc8ef7f69d1e44fe1b5cf35a.svg";
export { ForwardRef as ReactComponent };